<ng-template #dialogRef>
    <div class="cursor-pointer m-3">
      <i class="ri-close-line font-size-4 dark-color" (click)="close()"></i>
    </div>
    <div class="text-center " >
      <i class="ri-information-line  lite-color font-size-6rem"></i>
    </div>
    <div class="text-center">
        <p class="font-size-3 font-weight-700 dark-color m-0">
          {{'ConfirmDelete.TITLE'|translate}} {{title}}
    </p>  
        <p class="font-size-2 font-weight-400   lite-color m-0">
          {{'ConfirmDelete.BODY'|translate}} {{deletedName}}?
    </p>  
       
        <div class="w-100 row g-3 p-2 my-3">
            
        
          <div class="col-md-6">
            <button class="w-100 cancel_btn p-0 py-2" (click)="close()">   {{'Shared.CANCEL'|translate}}</button>
          </div>
          <div class="col-md-6">
            <button class="w-100 delete_btn p-0 py-2 "  (click)="confirm()"> {{'ConfirmDelete.DELETE'|translate}} </button>
            </div>
          </div>
    </div>
  </ng-template>